// import { useEffect, useState } from "react";
import { FETCH_CONTACTS_LIST as fetchContactsList } from "../../../../../graphql/query/Contact";
import {
  contactFilterStore,
  getContactSearchFromLocationSearch,
} from "../../../components/useContactFilters";

const SearchedContacts = props => {
  const { salesUserId } = props || {};
  const contactSearchFromUrl = getContactSearchFromLocationSearch(
    window.location.search,
  );
  const tableProps = {
    dataKey: "contactsV2",
    FETCH_QUERY: fetchContactsList({}),
    variables: {
      ...(contactSearchFromUrl ?? {}),
      ...(salesUserId ? { salesUserId } : {}),
    },
  };

  return tableProps;
};

export default SearchedContacts;
